var MovementProvider = /** @class */ (function () {
    function MovementProvider(props) {
        Object.assign(this, props);
        if (props.disabled_at) {
            this.disabled_at = new Date(props.disabled_at);
        }
    }
    return MovementProvider;
}());
export default MovementProvider;



//////////////////
// WEBPACK FOOTER
// ./src/modules/MovementProviders/Model.ts
// module id = 732
// module chunks = 0